/* tslint:disable */
/* eslint-disable */
/**
 * Poznejme Cesko API
 * Poznejme Cesko API Documentation
 *
 * OpenAPI spec version: v1.0.0
 * Contact: jan.fara@cleevio.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CreateFeedbackRequest } from '../models';
/**
 * UserFeedbackApi - axios parameter creator
 * @export
 */
export const UserFeedbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new feedback for logged user
         * @param {CreateFeedbackRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserFeedback: async (body: CreateFeedbackRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createUserFeedback.');
            }
            const localVarPath = `/users/me/feedbacks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            if (configuration && configuration.accessToken) {
                const accessToken = typeof configuration.accessToken === 'function'
                    ? await configuration.accessToken()
                    : await configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + accessToken;
            }

            // authentication x-platform required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("X-Platform")
                    : await configuration.apiKey;
                localVarHeaderParameter["X-Platform"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserFeedbackApi - functional programming interface
 * @export
 */
export const UserFeedbackApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create new feedback for logged user
         * @param {CreateFeedbackRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserFeedback(body: CreateFeedbackRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await UserFeedbackApiAxiosParamCreator(configuration).createUserFeedback(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserFeedbackApi - factory interface
 * @export
 */
export const UserFeedbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Create new feedback for logged user
         * @param {CreateFeedbackRequest} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserFeedback(body: CreateFeedbackRequest, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return UserFeedbackApiFp(configuration).createUserFeedback(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserFeedbackApi - object-oriented interface
 * @export
 * @class UserFeedbackApi
 * @extends {BaseAPI}
 */
export class UserFeedbackApi extends BaseAPI {
    /**
     * 
     * @summary Create new feedback for logged user
     * @param {CreateFeedbackRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserFeedbackApi
     */
    public async createUserFeedback(body: CreateFeedbackRequest, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return UserFeedbackApiFp(this.configuration).createUserFeedback(body, options).then((request) => request(this.axios, this.basePath));
    }
}
